export default __webpack_public_path__ + "static/media/23acf083-b36e-4baf-aabc-4935a5c4bdce.c088476a.woff";